<p-multiSelect
    [options]="getOptions(to.options)"
    [formControl]="formControl"
    [styleClass]="'form-control p-0 forms-multiselect'"
    (onChange)="change($event)"
    [resetFilterOnHide]="true"
    (onPanelHide)="blur($event)"
    [autofocusFilter]="false"
    [showClear]="false"
    [maxSelectedLabels]="10000"
></p-multiSelect>
